import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/system/shadows/shadows.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
